<template>
  <div class="popup">
      <!-- Modal -->
    <div class="modal fade" id="role" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mb-3">
                    <div class="col-4">
                        <div class="img-wrapper">
                            <img src="/img/popup-image.svg" alt="">
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="text-content">
                        <div class="d-flex justify-content-between">
                            <h5>Judith Lane</h5>
                            
                        </div>
                        <div class="d-flex">
                            <div class="designation mr-5">
                                Designation
                            </div>
                            <div class="social">
                                <img src="/img/popup/linkedin.svg" alt="" class="img-fluid mr-3">
                                <img src="/img/popup/twitter-square.svg" alt="" class="img-fluid mr-3">
                                <img src="/img/popup/facebook-square.svg" alt="" class="img-fluid mr-3">
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet et a nec cum dui at phasellus. Vel varius tristique netus pretium eu dui. Sit non malesuada lacus congue ut sollicitudin elementum lectus adipiscing. Enim dui etiam a egestas in aliquam fermentum, nullam. Facilisis dictumst turpis ac at vivamus aliquam, praesent. Purus facilisis leo, tristique aliquet suspendisse. Diam a ullamcorper euismod vestibulum arcu interdum cursus sit.</p>
                        <p>Elit non eget sodales etiam sed id tellus suspendisse non. Cursus sapien mi vel nibh molestie mi. Donec elementum tincidunt sagittis eu, non. Amet non nibh orci feugiat convallis. Vivamus malesuada risus convallis quam aenean id sagittis. Pretium, velit volutpat magna scelerisque tristique lorem hac. In sit suspendisse maecenas mattis duis vitae. Ligula facilisis ut ut justo, mauris. Elementum,</p>

                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
      <!-- <div class="popup-wrapper d-none">
      <div class="row mb-3">
          <div class="col-4">
              <div class="img-wrapper">
                  <img src="/img/popup-image.svg" alt="">
              </div>
          </div>
          <div class="col-8">
              <div class="d-flex justify-content-between">
                  <h5>Judith Lane</h5>
                  <img src="/img/popup/close.svg" alt="">
              </div>
              <div class="d-flex">
                  <div class="designation mr-5">
                      Designation
                  </div>
                  <div class="social">
                      <img src="/img/popup/linkedin.svg" alt="" class="img-fluid mr-3">
                      <img src="/img/popup/twitter-square.svg" alt="" class="img-fluid mr-3">
                      <img src="/img/popup/facebook-square.svg" alt="" class="img-fluid mr-3">
                  </div>
              </div>
          </div>
      </div>
      <div class="row">
          <div class="col-12">
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet et a nec cum dui at phasellus. Vel varius tristique netus pretium eu dui. Sit non malesuada lacus congue ut sollicitudin elementum lectus adipiscing. Enim dui etiam a egestas in aliquam fermentum, nullam. Facilisis dictumst turpis ac at vivamus aliquam, praesent. Purus facilisis leo, tristique aliquet suspendisse. Diam a ullamcorper euismod vestibulum arcu interdum cursus sit.</p>
              <p>Elit non eget sodales etiam sed id tellus suspendisse non. Cursus sapien mi vel nibh molestie mi. Donec elementum tincidunt sagittis eu, non. Amet non nibh orci feugiat convallis. Vivamus malesuada risus convallis quam aenean id sagittis. Pretium, velit volutpat magna scelerisque tristique lorem hac. In sit suspendisse maecenas mattis duis vitae. Ligula facilisis ut ut justo, mauris. Elementum,</p>

          </div>
      </div>
      </div> -->
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
    // .popup {
        
    //     .popup-wrapper {
    //         position: absolute;
    //         width: 40%;
    //         //margin: 0 auto;
    //         background: #FFFFFF;
    //         box-shadow: 0px 4px 32px rgba(0, 0, 0, 0.25);
    //         border-radius: 8px;
    //         padding: 1.5rem;
    //         top: 50%;
    //         left: 50%;
    //         transform: translate(-50%, -50%);
    //         z-index: 100;

    //         .img-wrapper {
    //             margin-top: -4rem;
    //         }

    //         h5 {
    //             font-weight: bold;
    //             font-size: 24px;
    //             line-height: 36px;
    //             color: #2C3C90;
    //         }

    //         .designation {
    //             font-family: Poppins;
    //             font-style: normal;
    //             font-weight: normal;
    //             font-size: 16px;
    //             line-height: 24px;
    //             color: #2C3C90;
    //         }

            
    //     }
    // }

    .popup {
            
        .modal-content {
            .modal-header {
                border-bottom: none;
            }

            .img-wrapper {
                img {
                    height: 8rem;
                    margin-top: -3rem;
                }
            }

            .text-content {
                margin-top: -3rem;
                margin-right: 1rem;

                h5 {
                    font-weight: bold;
                    font-size: 24px;
                    line-height: 36px;
                    color: #2C3C90;
                }

                .designation {
                    font-family: Poppins, sans-serif;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 16px;
                    line-height: 24px;
                    color: #2C3C90;
                }
            }
            
            button:focus {
                outline: none;
            }
            
        } 
    
    }

    @media (min-width: 992px) and (max-width: 1199px) {
        .popup {
            .popup-wrapper {
                .img-wrapper {
                    img {
                        height: 8rem;
                    }
                }

                .designation {
                    margin-right: 1rem !important;
                }

                .social {
                    .img {
                        margin-right: .5rem !important;
                    }
                }
            }
        }
    }

    @media (min-width: 768px) and (max-width: 991px) {
        .popup {
            .popup-wrapper {
                width: 54%;
                .img-wrapper {
                    img {
                        height: 8rem;
                    }
                }

                .designation {
                    margin-right: 1rem !important;
                }

                .social {
                     margin-right: .5rem !important;
                }
            }
        }
    }

    @media (max-width: 767px) {
        .popup {
            .popup-wrapper {
                width: 60%;
                .img-wrapper {
                    img {
                        height: 8rem;
                    }
                }

                .designation {
                    margin-right: 1rem !important;
                }

                .social {
                    img {
                        margin-right: .5rem !important;
                    }
                }
            }
        }
    }

    @media (max-width: 645px) {
        .popup {
            .popup-wrapper {
                width: 72%; 
            }
        }
    }

    @media (max-width: 544px) {
        .popup {
            .popup-wrapper {
                width: 90%; 

                .img-wrapper {
                    img {
                        height: 6rem;
                    }
                }

                .designation {
                    font-size: 15px;
                }
                
                .social {
                    img {
                        margin-right: .2rem !important;
                    }
                }
                
            }
        }
    }

    // @media (max-width: 370px) {
    //     .popup {
    //         .popup-wrapper {

    //             h5 {
    //                 font-size: 17px;
    //             }
                
    //             .designation {
    //                 font-size: 11px;
    //                 margin-right: .5rem !important;
    //             }
                
    //         }
    //     }
    // }

     @media (max-width: 479px) {
        .popup {
            
            .modal-content {
                .img-wrapper {
                    img {
                        height: 5rem;
                        margin-top: -3rem;
                    }
                }

                .text-content {
                    margin-top: -3rem;

                    h5 {
                        font-size: 1.25rem;
                    }

                     .designation {
                        //font-size: .8rem;
                        margin-right: 1rem !important;
                    }

                    .social {
                        img {
                            height: 1rem;
                            margin-right: .5rem!important;
                        }
                    }
                }
                
               
            } 
        
        }
    }

    @media (max-width: 385px) {
        .popup {
            
            .modal-content {
                .img-wrapper {
                    img {
                        height: 5rem;
                        margin-top: -3rem;
                    }
                }

                .text-content {
                    margin-top: -3rem;

                    .designation {
                        font-size: .8rem;
                        margin-right: 1rem !important;
                    }

                    .social {
                        img {
                            height: 1rem;
                            margin-right: .3rem!important;
                        }
                    }
                }
                
            } 
        
        }
    }

     @media (max-width: 349px) {
        .popup {
            
            .modal-content {

                .text-content {

                    .designation {
                        font-size: .7rem;
                        margin-right: .9rem !important;
                    }

                    .social {
                        img {
                            height: .8rem;
                            margin-right: .3rem!important;
                        }
                    }
                }
                
            } 
        
        }
    }

    
</style>